import type { ApiListRequest, ApiListResponseV3 } from "../@types/services/Api";
import type {
  Status,
  StatusesFilter,
  StatusesOrder,
} from "../@types/services/Status";
import { api } from "./api";

const API_BASE_URL = "/api/v3/statuses";

export const showStatus = async (id: Status["id"]): Promise<Status> => {
  const response = await api.get<Status>(`/${id}`, {
    baseURL: API_BASE_URL,
  });
  return response.data;
};

export const listStatuses = async ({
  filters,
  orders,
  ...rest
}: ApiListRequest<StatusesFilter, StatusesOrder> = {}): Promise<
  ApiListResponseV3<Status>
> => {
  const response = await api.get<ApiListResponseV3<Status>>("", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
      ...orders,
      ...rest,
    },
  });
  return response.data;
};
